<template>
    <div>
        <component :is="hideTitle ? 'div' : 'card'" :title="hideTitle ? '' : 'Pharmacy Record Page'">
            <SearchComponent v-if="!newMode" :disabled="!!(pharmacyDetail.id)" v-model="pharmacyDetail"
                :search-u-r-l="`/StoredPharmacy`" :params="{ showOnlyActive: false }"
                :id="pharmacyDetail && pharmacyDetail.id" @input="onPharmacyChange"></SearchComponent>
            <b-row>
                <b-col>
                    <checkbox class="form-check" v-model="pharmacyDetail.isActive" :disabled="disableFields" required>
                        Is Pharmacy active?
                    </checkbox>
                </b-col>
                <b-col>
                    <checkbox class="form-check" v-model="pharmacyDetail.inNetwork" :disabled="disableFields">
                        Is Pharmacy In Network?
                    </checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <checkbox class="form-check" v-model="pharmacyDetail.supportsTransferMyRx" :disabled="disableFields">
                        Supports TransferMyRx
                    </checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <fg-input v-model="pharmacyDetail.name" label="Pharmacy Name" :disabled="disableFields" required>
                    </fg-input>
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.address" label="Address" :disabled="disableFields">
                    </fg-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <fg-input v-model="pharmacyDetail.addressCity" label="City" :disabled="disableFields">
                    </fg-input>
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.addressState" label="State" :disabled="disableFields">
                    </fg-input>
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.addressZip" label="ZIP" :disabled="disableFields">
                    </fg-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <fg-input v-model="pharmacyDetail.phoneNumber" label="Phone" :disabled="disableFields" required>
                    </fg-input>
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.faxNumber" label="Fax" :disabled="disableFields" required>
                    </fg-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <fg-input v-model="pharmacyDetail.npiNumber" label="NPI Number" :disabled="disableFields" />
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.storeNumber" label="Store Number" :disabled="disableFields" />
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <fg-input v-model="pharmacyDetail.dea" label="DEA" :disabled="disableFields">
                    </fg-input>
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.ncpdp" label="NCPDP" :disabled="disableFields" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <fg-input v-model="pharmacyDetail.latitude" label="Latitude" type="number" step="0.000001"
                        :disabled="disableFields" />
                </b-col>
                <b-col>
                    <fg-input v-model="pharmacyDetail.longitude" label="Longitude" type="number" step="0.000001"
                        :disabled="disableFields" />
                </b-col>
            </b-row>

            <NewClearSaveButtons :titles="buttonTitles" :disable="disableFields" :disable-clear="disableFields"
                :disable-save="!isFormValid" @clear-clicked="clearForm" @new-clicked="createStoredPharma"
                @save-clicked="saveStoredPharmacy" @cancel-clicked="$emit('close')" />

            <div class="text-center">
                <b-button variant="primary" @click="$bvModal.show('directorySearch')">
                    <i class="fa fa-search" />
                    Directory Search...
                </b-button>
            </div>

            <!--
                    TABLE OF PHARMACISTS
                    FROM StoredPharmacist
                    WHERE ID = CURRENT PHARMACY
            -->
            <b-row v-if="pharmacyDetail && pharmacyDetail.id">
                <b-col>
                    <h3> Stored Pharmacist: </h3>
                    <b-table id="stored-pharmacist-table" :items="pharmacists" :fields="pharmacistsFields"
                        empty-text="No Pharmacists" show-empty striped bordered>
                        <template #cell(isActive)="row">
                            <b-checkbox v-model="row.item.isActive" @change="updateActive(row.item)"></b-checkbox>
                        </template>
                    </b-table>

                    <b-button variant="success" @click="newStoredPharmacist"
                        :disabled="!pharmacyDetail || !pharmacyDetail.id">Create New
                        Pharmacist
                    </b-button>
                </b-col>
            </b-row>
        </component>

        <b-modal id="directorySearch" hide-footer size="xl" title="Pharmacy Directory Search" scrollable>
            <PharmacyDirectorySearch @input="handleDirectorySelect" />
        </b-modal>

        <b-modal id="addNewPharmacist" hide-footer size="xl" no-close-on-backdrop title="Create New Pharmacist">
            <PharmacistDetailPage :disabled="!pharmacyDetail || !pharmacyDetail.id"
                :pharmacy-id="pharmacyDetail && +pharmacyDetail.id" new-mode @saveClicked="saveStoredPharmacist"
                @close="$bvModal.hide('addNewPharmacist')" @created="onPharmacistCreate"></PharmacistDetailPage>
        </b-modal>
    </div>
</template>

<script lang="ts">
import axios from 'axios';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SearchComponent from '@/components/SearchComponent.vue';
import NewClearSaveButtons, { NewClearSaveTitles } from '@/components/NewClearSaveButtons.vue';
import { PharmacyRecord } from "@/models/Pharmacy"
import { PharmacistRecord } from "@/models/Pharmacist";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import Checkbox from "@/components/Inputs/Checkbox.vue";
import PharmacistDetailPage from "@/pages/Pharmacist/PharmacistDetailPage.vue";
import NotificationTypes = NotificationOptions.NotificationTypes;
import PharmacyDirectorySearch from '@/components/PharmacyDirectorySearch.vue';

@Component({
    name: 'PharmacyDetailPage',
    components: {
        PharmacistDetailPage,
        SearchComponent,
        NewClearSaveButtons,
        Checkbox,
        PharmacyDirectorySearch
    }
})
export default class PharmacyDetailPage extends Vue {

    protected pharmacists: PharmacistRecord[] = [];
    private pharmacyDetail: PharmacyRecord = new PharmacyRecord();
    private pharmacistDetail: PharmacistRecord = new PharmacistRecord();

    private pharmacistsFields = [
        "id",
        "firstName",
        "lastName",
        "isActive",
    ];

    @Prop({ type: Number, default: 0 }) private pharmacyId!: number;
    @Prop({ type: Boolean, default: false }) private newMode!: boolean;
    @Prop({ default: false }) private hideTitle!: boolean;
    @Prop({ default: false }) private defaultToActive!: boolean;

    created() {
        this.pharmacyDetail.isActive = this.defaultToActive;
        if (this.pharmacyId) {
            this.pharmacyDetail.id = this.pharmacyId;
            this.onPharmacyChange(this.pharmacyDetail);
        }

        if (this.newMode) {
            this.$nextTick(() => {
                this.$bvModal.show('directorySearch');
            })
        }
    }

    @Watch("pharmacyId")
    onPharmacyIdChanged(value: number, oldValue: number) {
        if (value === oldValue) return;

        if (value) {
            this.pharmacyDetail.id = value;
            this.onPharmacyChange(this.pharmacyDetail);
        } else {
            this.clearForm();
        }
    }

    onPharmacyChange(_value: PharmacyRecord) {
        if (this.pharmacyDetail.id) {
            axios.get<PharmacyRecord>(`/StoredPharmacy/${this.pharmacyDetail.id}`)
                .then(pbmResponse => {
                    this.pharmacyDetail = new PharmacyRecord(pbmResponse.data);
                }).catch(err => this.$notification(NotificationOptions.error(err)));
        }

        //  LOAD ALL THE PHARMACISTS FOR A GIVEN PHARMACY AFTER IT HAS BEEN SELECTED
        this.loadPharmacists();
    }

    //  THIS GETS ALL OF THE STORED PHARMACISTS ASSOCIATED WITH A SPECIFIC PHARMACY
    async loadPharmacists() {
        axios.get<PharmacistRecord[]>(`/StoredPharmacist/GetAllPharmacistsByStore/${this.pharmacyDetail.id}`).then((response) => {
            this.pharmacists = response.data;
        }).catch((error) => {
            console.error("Problem loading Pharmacists by Pharmacy", { error, response: error?.response });
            this.$notification(NotificationOptions.error(error));
        });
    }

    get disableFields(): boolean {
        return (this.pharmacyDetail?.id || 0) == 0 && !this.newMode;
    }

    get isFormValid() {
        return this.pharmacyDetail.name && this.pharmacyDetail.faxNumber && this.pharmacyDetail.phoneNumber;
    }

    @Prop({
        default: () => {
            return {
                new: "New Pharmacy",
                clear: "Clear",
                save: "Save Changes",
                cancel: "Cancel",
            };
        }
    }) protected buttonTitles!: NewClearSaveTitles;

    createStoredPharma() {
        this.newMode = true;
        this.pharmacyDetail = new PharmacyRecord();
    }

    clearForm() {
        this.newMode = false;
        this.pharmacyDetail = new PharmacyRecord();
    }

    async saveStoredPharmacy() {
        // Check if DEA is missing and show confirmation dialog
        if (!this.pharmacyDetail.dea) {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                'This pharmacy does not have a DEA number. DEA numbers are required to transfer controlled substances. Are you sure you want to save without a DEA number?',
                {
                    title: 'Missing DEA Number',
                    okVariant: 'warning',
                    okTitle: 'Save Anyway',
                    cancelTitle: 'Cancel',
                    centered: true,
                    noFade: true,
                }
            );
            if (!confirmed) return;
        }

        if (this.pharmacyDetail?.id as number) this.pharmacyDetail.id = this.pharmacyDetail.id as number;
        else this.pharmacyDetail.id = null as unknown as number;
        axios.post<{ pharmacy: PharmacyRecord, warning: string }>('/StoredPharmacy', this.pharmacyDetail)
            .then(response => {
                let pharm = response.data.pharmacy;
                let warning = response.data.warning;
                if (pharm.id) {
                    this.pharmacyDetail = new PharmacyRecord(pharm);
                    this.$notification(NotificationOptions.successSaveNotificationPreset("Pharmacy"));
                    this.$emit('created', this.pharmacyDetail);
                }
                if (warning) {
                    this.$notification(NotificationOptions.warning(warning));
                }
            })
            .catch(error => {
                this.$notification(NotificationOptions.errorSaveNotificationPreset("Pharmacy", error));
            });
    }

    saveStoredPharmacist() {
        this.pharmacistDetail.pharmacyId = this.pharmacyId;
        if (this.pharmacistDetail?.id as number) this.pharmacistDetail.id = this.pharmacistDetail.id as number;
        else this.pharmacistDetail.id = null as unknown as number;

        axios.post<PharmacistRecord>('/SavePharmacist', this.pharmacistDetail)
            .then(response => {

                if (response.data.id) {
                    this.loadPharmacists();
                    this.pharmacistDetail = Object.assign(new PharmacistRecord(), response.data);
                    this.$notification(NotificationOptions.successSaveNotificationPreset("Pharmacist"));
                    this.$emit('created', this.pharmacistDetail);
                }
            })
            .catch(error => {
                this.$notification(NotificationOptions.errorSaveNotificationPreset("Pharmacist", error));
            });
    }

    onPharmacistCreate(newPharmacist: PharmacistRecord) {
        this.pharmacistDetail = newPharmacist;
        this.$bvModal.hide("addNewPharmacist");
    }

    updateActive(pharmacist: PharmacistRecord) {
        console.log("pharmacist: ", pharmacist);
        axios.post<PharmacistRecord>('/StoredPharmacist', pharmacist)
            .then(response => {

                if (response.data.id) {
                    this.loadPharmacists();
                    this.pharmacistDetail = Object.assign(new PharmacistRecord(), response.data);
                    this.$notification(NotificationOptions.successSaveNotificationPreset("Pharmacist"));
                    this.$emit('created', this.pharmacistDetail);
                }
            })
            .catch(error => {
                this.$notification(NotificationOptions.errorSaveNotificationPreset("Pharmacist", error));
            });
    }

    newStoredPharmacist() {
        this.pharmacistDetail = new PharmacistRecord();
        this.pharmacistDetail.isActive = true;
        this.$bvModal.show("addNewPharmacist");
    }

    handleDirectorySelect(i: any) {
        this.$bvModal.hide('directorySearch');

        this.pharmacyDetail = Object.assign(new PharmacyRecord(), {
            id: 0,
            name: i.organization.organizationName,
            address: i.organization.address?.addressLine1,
            addressCity: i.organization.address?.city,
            addressState: i.organization.address?.stateProvince,
            addressZip: i.organization.address?.postalCode,
            phoneNumber: i.organization.communicationNumbers?.primaryTelephone?.number,
            faxNumber: i.organization.communicationNumbers?.fax?.number,
            npiNumber: i.organization.identification.npi,
            storeNumber: i.organization.identification.storeNumber,
            dea: i.organization.identification.deaNumber,
            ncpdp: i.organization.identification.ncpdpid,
            pharmacist: "",
            isActive: true
        });
        this.newMode = true;
    }

}
</script>

<style scoped>
.form-check {
    margin-top: 0;
    padding-left: 0;
}
</style>
